import React, { Component } from 'react';
import { Modal, Icon } from 'semantic-ui-react'
import Draggable from 'react-draggable'
import {MidQryInput, QueryOutput} from 'kx-common-components'

export class MidModal extends Component {
    constructor(props) {
        super(props);
        this.state = { qryType: null, midModalOpened: false ||this.props.modalStartsOpened, selectedResult: null }
        this.setQryType = this.setQryType.bind(this);
        this.setSelectedResult = this.setSelectedResult.bind(this)
        this.close = this.close.bind(this)
    }

    setQryType(qryType) {
      this.setState({"qryType": qryType}); 
    }

    setSelectedResult(payload) {
      this.setState({"selectedResult": payload});
    }
    close() {
      this.props.parentCloseFunction && this.props.parentCloseFunction();
      this.setState({"midModalOpened": false})
    }
    render(){
      return (
        <Draggable
        handle=".query-inputs"
        ><Modal
            id={`midQryModal`}
            closeIcon
            className={'midQryModal'}
            style={{"top":"40px", "width": "525px"}}
            header={this.props.headerTitle}
            trigger={this.props.trigger}
            launchFrom={'MF_FORM'}
            open={this.state.midModalOpened}
            onOpen={()=>{
              this.setState({"midModalOpened": true})}
            }
            onClose={()=>{
              this.props.parentCloseFunction && this.props.parentCloseFunction();
              this.setState({"midModalOpened": false})}
            }
            closeOnDimmerClick={false}
          >   
            <div className="query-inputs">Query Input</div>   
              <MidQryInput 
                loggedInUserEmail={this.props.loggedInUserEmail}
                savedInContextOf={this.props.savedInContextOf}
                brokerId={this.props.brokerId} 
                shipmentId={this.props.shipmentId}
                setQryType={this.setQryType}
                isModalOpened={this.state.midModalOpened}
                setSelectedResult={this.setSelectedResult}
                data={this.props.data}
                saveToActorRefOnly={this.props.saveToActorRefOnly}
              />   
              <React.Fragment>
              <div
                  ref={el => (this.componentRef = el)} 
                  id="qryFuncRightPanel"
              >
              <QueryOutput 
                  loggedInUserEmail={this.props.loggedInUserEmail}
                  savedInContextOf={this.props.savedInContextOf}
                  launchFrom={`MF_FORM`}
                  runAgainClicked={this.onRunAgainClicked} 
                  {...this.props} 
                  qryType={this.state.qryType} 
                  selectedResultList={this.state.selectedResult}
                  set_MF_Form_Data={this.props.set_MF_Form_Data}
                  closeModal={this.close}
                  data={this.props.data}
                  saveToActorRefOnly={this.props.saveToActorRefOnly}
              />
              </div>
              <div id='brokerQryToast' className={`toast`}></div>
            </React.Fragment>
          </Modal></Draggable>
      )
    }
}

export default MidModal

